import React, { useState } from "react";
import "./css/contact.css";
import { Form, Row, Col, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRotateRight, faLocationDot, faPhone } from "@fortawesome/free-solid-svg-icons";
import Loader from "./Loader/Loader";
import America from "./img/location/america.png";
import Singapore from "./img/location/singapore.png";
import India from "./img/location/india.png";
import { Country, State, City } from "country-state-city";

// Function to generate random alphanumeric string
const generateCaptcha = () => {
  const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let captcha = "";
  for (let i = 0; i < 6; i++) {
    captcha += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return captcha;
};

const Contact = () => {

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    jobTitle: "",
    companyName: "",
    phone: "",
    companySize: "",
    country: "",
    state: "",
    city: "",
    message: "",
  });


  const [loading, setLoading] = useState(false);
  const [captcha, setCaptcha] = useState(generateCaptcha());
  const [captchaInput, setCaptchaInput] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      alert("Please enter a valid email address.");
      return;
    }

    // Captcha validation
    if (captchaInput !== captcha) {
      alert("Captcha is incorrect! Try again.");
      setCaptcha(generateCaptcha()); // regenerate captcha
      setCaptchaInput("");
      return;
    }
    // console.log(formData);
    setLoading(true)
    try {

      const response = await fetch("https://tiara.software/api/email/send", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });


      if (!response.ok) {
        throw new Error("Failed to send message");
      }

      const result = await response.json(); // parse JSON response
      // console.log("Form submitted:", result);

      // show message from backend
      alert(result.message);


      // Reset form
      setFormData({
        firstName: "",
        lastName: "",
        email: "",
        jobTitle: "",
        companyName: "",
        phone: "",
        companySize: "",
        country: "",
        state: "",
        city: "",
        message: "",
      });
      setCaptcha(generateCaptcha());
      setCaptchaInput("");

    } catch (error) {
      console.error("Error submitting form:", error);
      alert("Something went wrong. Please try again.");
    }
    finally {
      setLoading(false)
    }
  };

  return (

    <div className="contact-section">

      <div className="contact-container row">
        {loading && <Loader />}
        {/* Left: Contact Form */}

        <div className="col-xxl-7 col-xl-7 col-lg-7 col-md-12 col-sm-12 custom-padding">
          <div className="card contact-form">
            {/* <h2>Contact Us</h2> */}
            <Form onSubmit={handleSubmit} className="p-3 border rounded shadow bg-light contact-field-area">
              {/* First & Last Name */}
              <div className="row">
                <div className="col-lg-6 col-md-6 col-sm-12">
                  <div className="form-group mb-1">
                    <label htmlFor="formFirstName">First Name</label>
                    <input
                      id="formFirstName"
                      className="form-control"
                      type="text"
                      name="firstName"
                      value={formData.firstName}
                      onChange={handleChange}
                      required
                      placeholder="Enter first name"
                    />
                  </div>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12">
                  <div className="form-group mb-1">
                    <label htmlFor="formLastName">Last Name</label>
                    <input
                      id="formLastName"
                      className="form-control"
                      type="text"
                      name="lastName"
                      value={formData.lastName}
                      onChange={handleChange}
                      required
                      placeholder="Enter last name"
                    />
                  </div>
                </div>
              </div>

              {/* Email & Job Title */}
              <div className="row">
                <div className="col-lg-6 col-md-6 col-sm-12">
                  <div className="form-group mb-1">
                    <label htmlFor="formEmail">Email</label>
                    <input
                      id="formEmail"
                      className="form-control"
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      placeholder="Enter email"
                    />
                  </div>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12">
                  <div className="form-group mb-1">
                    <label htmlFor="formJobTitle">Job Title</label>
                    <input
                      id="formJobTitle"
                      className="form-control"
                      type="text"
                      name="jobTitle"
                      value={formData.jobTitle}
                      onChange={handleChange}
                      required
                      placeholder="Enter job title"
                    />
                  </div>
                </div>
              </div>

              {/* Company Name & Phone */}
              <div className="row">
                <div className="col-lg-6 col-md-6 col-sm-12">
                  <div className="form-group mb-1">
                    <label htmlFor="formCompanyName">Company Name</label>
                    <input
                      id="formCompanyName"
                      className="form-control"
                      type="text"
                      name="companyName"
                      value={formData.companyName}
                      onChange={handleChange}
                      required
                      placeholder="Enter company name"
                    />
                  </div>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12">
                  <div className="form-group mb-1">
                    <label htmlFor="formPhone">Phone Number</label>
                    <input
                      id="formPhone"
                      className="form-control"
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      required
                      placeholder="Enter phone number"
                    />
                  </div>
                </div>
              </div>

              {/* Company Size Dropdown */}
              <div className="row">
                <div className="col-lg-6 col-md-6 col-sm-12">
                  <div className="form-group mb-1">
                    <label htmlFor="formCompanySize">Company Size</label>
                    <select
                      id="formCompanySize"
                      className="form-select"
                      name="companySize"
                      value={formData.companySize}
                      onChange={handleChange}
                      required
                    >
                      <option value="">-- Select Company Size --</option>
                      <option value="1-10">1 - 10 employees</option>
                      <option value="11-50">11 - 50 employees</option>
                      <option value="51-200">51 - 200 employees</option>
                      <option value="201-500">201 - 500 employees</option>
                      <option value="501-1000">501 - 1000 employees</option>
                      <option value="1000+">1000+ employees</option>
                    </select>
                  </div>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12">
                  <div className="form-group mb-1">
                    <label>Country</label>
                    <select
                      className="form-select"
                      name="country"
                      value={formData.country}
                      onChange={handleChange}
                      required
                    >
                      <option value="">-- Select Country --</option>
                      {Country.getAllCountries().map((country) => (
                        <option key={country.isoCode} value={country.isoCode}>
                          {country.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>



              <div className="row">
                <div className="col-lg-6 col-md-6 col-sm-12">
                  <div className="form-group mb-1">
                    <label>State</label>
                    <select
                      className="form-select"
                      name="state"
                      value={formData.state}
                      onChange={handleChange}
                      required
                      disabled={!formData.country}
                    >
                      <option value="">-- Select State --</option>
                      {State.getStatesOfCountry(formData.country).map((state) => (
                        <option key={state.isoCode} value={state.isoCode}>
                          {state.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12">
                  <div className="form-group mb-1">
                    <label>City</label>
                    <select
                      className="form-select"
                      name="city"
                      value={formData.city}
                      onChange={handleChange}
                      required
                      disabled={!formData.state}
                    >
                      <option value="">-- Select City --</option>
                      {City.getCitiesOfState(formData.country, formData.state).map((city) => (
                        <option key={city.name} value={city.name}>
                          {city.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>



              {/* Message */}
              <div className="form-group">
                <label htmlFor="formMessage">Enquire</label>
                <textarea
                  id="formMessage"
                  className="form-control"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  rows={4}
                  required
                  placeholder="Enter your message"
                ></textarea>
              </div>

              {/* Captcha */}
              <Form.Group className="mb-3 d-flex flex-column " controlId="formCaptcha">
                <Form.Label className="d-flex flex-column ">Captcha</Form.Label>
                <div className="d-flex   align-items-center" style={{ gap: "15px" }}>
                  <Form.Control
                    type="text"
                    value={captchaInput}
                    onChange={(e) => setCaptchaInput(e.target.value)}
                    required
                    placeholder="Enter captcha text"
                    style={{ maxWidth: "200px" }}
                  />
                  <div className="d-flex align-items-center">
                    <span
                      className="captcha-box"
                    >
                      {captcha}
                    </span>
                    <Button
                      variant="light"
                      size="sm"
                      type="button"
                      onClick={() => {
                        setCaptcha(generateCaptcha());
                        setCaptchaInput("");
                      }}
                      style={{
                        border: "1px solid #ccc",
                        borderRadius: "50%",
                        height: "40px",
                        width: "40px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <FontAwesomeIcon icon={faRotateRight} />
                    </Button>
                  </div>


                </div>
              </Form.Group>

              <Button type="submit" variant="primary" className="w-100 btnmesg">
                Submit
              </Button>
            </Form>

          </div>
        </div>

        {/*Address Section*/}
        <div className="col-xxl-5 col-xl-5 col-lg-5 col-md-12 col-sm-12 custom-padding">
          <div className="address-info">

            {/*US Address*/}
            <div className="address-card">

              <div className="address-header">
                {/* <div className="add-img-container">
                  <img src={America} className="address-img" />
                </div> */}
                <div className="address-heading ">US Region</div>
              </div>

              <div className="address-content address-border">
                <div className="flex-row location-header">
                  <FontAwesomeIcon icon={faLocationDot} className="location-pin" />
                  <strong className="place">California</strong></div>
                <div className="address-txt">9110 Alcosta Blvd, Suite H, San Ramon CA, 94583</div>
              </div>

              <div className="address-content address-border">
                <div className="flex-row location-header">
                  <FontAwesomeIcon icon={faLocationDot} className="location-pin" />
                  <strong className="place">District of Columbia (DC)</strong></div>
                <div className="address-txt">714 G St SE, Ste. 200, Washington DC, 20003</div>
              </div>

              <div className="address-content">
                <div className="flex-row location-header">
                  <FontAwesomeIcon icon={faLocationDot} className="location-pin" />
                  <strong className="place">Texas</strong></div>
                <div className="address-txt">8408 Preston Road, Ste. 330-163, Plano, TX 75024</div>
              </div>
            </div>

            {/*Singapore Address*/}
            <div className="address-card">

              <div className="address-header">
                {/* <div className="add-img-container">
                  <img src={Singapore} className="address-img" />
                </div> */}
                <div className="address-heading">Singapore</div>
              </div>

              <div className="address-content">
                <div className="flex-row location-header">
                  <FontAwesomeIcon icon={faLocationDot} className="location-pin" />
                  <strong className="place">Tanjong Pagar</strong></div>
                <div className="address-txt"> 100 Tras Street, #16-01, The Amara Corporate Tower, Singapore 079027</div>

                <div className="flex-row location-header"><FontAwesomeIcon icon={faPhone} className="phone-pin" />
                  <strong className="address-txt"> +65-6423 0030</strong></div>
              </div>
            </div>

            {/*India Address*/}
            <div className="address-card">

              <div className="address-header">
                {/* <div className="add-img-container">
                  <img src={India} className="address-img" />
                </div> */}
                <div className="address-heading">India - Global Development Centers</div>
              </div>

              <div className="address-content address-border">
                <div className="flex-row location-header">
                  <FontAwesomeIcon icon={faLocationDot} className="location-pin" />
                  <strong className="place">Chennai</strong></div>
                <div className="address-txt">SP3, 5th Avenue, Ashok Nagar, Chennai - 600 083, Tamil Nadu</div>
                <div className="flex-row location-header"><FontAwesomeIcon icon={faPhone} className="phone-pin" />
                  <strong className="address-txt"> +91-9344931575</strong></div>
              </div>


              <div className="address-content address-border">
                <div className="flex-row location-header">
                  <FontAwesomeIcon icon={faLocationDot} className="location-pin" />
                  <strong className="place">Virudhunagar</strong></div>
                <div className="address-txt"> Near Theppakulam / Burma Kadai area, Virudhunagar - 626 001, <br /> Tamil Nadu</div>
                <div className="flex-row location-header"><FontAwesomeIcon icon={faPhone} className="phone-pin" />
                  <strong className="address-txt"> +91-9344931577</strong></div>
              </div>


              <div className="address-content">
                <div className="flex-row location-header">
                  <FontAwesomeIcon icon={faLocationDot} className="location-pin" />
                  <strong className="place">Madurai</strong></div>
                <div className="address-txt"> 55/2A, Plot No. 17, Sri Ramakrishna Nagar, Pasinga Puram,</div>
                <div className="address-txt"> Madurai - 625 018, Tamil Nadu</div>
                <div className="flex-row location-header"><FontAwesomeIcon icon={faPhone} className="phone-pin" />
                  <strong className="address-txt"> +91-9344931577</strong></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  );
};

export default Contact;
